/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/ip',
    path: '/1024//85',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/ethernet/ip',
    path: '/1024//85',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getGatewayIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/gateway-ip',
    path: '/1024//86',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putGatewayIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/ethernet/gateway-ip',
    path: '/1024//86',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getIpMask: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/ip-mask',
    path: '/1024//87',
    responseBodyDecoder: allConverters.stringIpv4mask,
  } as ServiceCallType<void, string>,

  putIpMask: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/ethernet/ip-mask',
    path: '/1024//87',
    bodyEncoder: allConverters.stringIpv4mask,
  } as ServiceCallType<string, void>,

  getHostname: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/hostname',
    path: '/1024//93',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getDnsIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/dns-ip',
    path: '/1024//124',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putDnsIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/ethernet/dns-ip',
    path: '/1024//124',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getEnabled: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/ethernet/enabled',
    path: '/1024//130',
    responseBodyDecoder: allConverters.boolean,
  } as ServiceCallType<void, boolean>,

  putEnabled: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/ethernet/enabled',
    path: '/1024//130',
    bodyEncoder: allConverters.boolean,
  } as ServiceCallType<boolean, void>,
};
